import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AsyncScheduler } from 'rxjs/internal/scheduler/AsyncScheduler';

import { CalendarService } from '@finder/shared/services/calendar-service/calendar-service.service';
import { CurrencyConverterService } from '@finder/shared/components/currency-converter/currency-converter.service';
import { FeatureDetectionService } from '@finder/shared/services/feature-detection/feature-detection.service';
import { FinderLayoutComponent } from '@finder/shared/components/finder-layout/finder-layout.component';
import { FontIconLoaderComponent } from '@finder/shared/components/font-icon-loader/font-icon-loader.component';
import { HeaderOverridesService } from '@finder/shared/services/header-overrides/header-overrides.service';
import { ModalService } from '@finder/shared/components/modal/modal.service';
import { SyndicatedFooterComponent } from '@finder/shared/components/syndicated-layout/syndicated-footer/syndicated-footer.component';
import { SyndicatedHeaderComponent } from '@finder/shared/components/syndicated-layout/syndicated-header/syndicated-header.component';
import { SystemErrorComponent } from '@finder/shared/components/system-error/system-error.component';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { ScriptLoaderModule } from '@finder/shared/components/script-loader/script-loader.module';
import { LoadingSpinnerModule } from '@finder/shared/components/loading-spinner/loading-spinner.module';
import { CssLoaderModule } from '@finder/shared/components/css-loader/css-loader.module';
import { FinderButtonModule } from './finder-button/finder-button.module';
import { InfiniteScrollingComponent } from '@finder/shared/components/infinite-scrolling/infinite-scrolling.component';
import { SafeHtmlPipeModule } from '@finder/shared/utils/pipes/safe-html/safe.html.module';

const exportableComponents = [
    FinderLayoutComponent,
    FontIconLoaderComponent,
    SyndicatedFooterComponent,
    SyndicatedHeaderComponent,
    SystemErrorComponent,
    InfiniteScrollingComponent
];

const exportableProviders = [
    { provide: AsyncScheduler, useValue: AsyncScheduler },
    CalendarService,
    CurrencyConverterService,
    CurrencyPipe,
    DecimalPipe,
    FeatureDetectionService,
    HeaderOverridesService,
    ModalService,
    WindowRef,
];

const exportableModules = [
    ScriptLoaderModule,
    LoadingSpinnerModule,
    CssLoaderModule,
    FinderButtonModule,
    SafeHtmlPipeModule
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ...exportableModules,
    ],
    declarations: [...exportableComponents],
    exports: [...exportableComponents, ...exportableModules],
    providers: exportableProviders,
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
})
export class ComponentsModule {
}
